import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Calendar date as YYYY-MM-DD in the user's local timezone (not UTC — avoids `toISOString()` day drift). */
export function localDateISOString(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function localDateMinusDaysISO(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return localDateISOString(d);
}

/**
 * Format a stored date-only field (`YYYY-MM-DD`). Parsing as UTC shifts the calendar day in many
 * timezones; use local midnight instead.
 */
export function formatDateOnlyLocal(
  dateStr: string | null,
  options: Intl.DateTimeFormatOptions,
  locale = "en-US",
): string {
  if (!dateStr) return "--";
  const parsed = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr.trim());
  if (!parsed) {
    return new Date(dateStr).toLocaleDateString(locale, options);
  }
  const y = Number(parsed[1]);
  const mo = Number(parsed[2]);
  const da = Number(parsed[3]);
  return new Date(y, mo - 1, da).toLocaleDateString(locale, options);
}
